/** Mantine NumberInput emits `string | number` — in-progress decimals,
 * pasted formatted values ("1,500", "£1,500") and locale artefacts all
 * arrive as strings. Parse what we can instead of silently discarding
 * (discarding resets the field state, so dirty-tracking never fires and
 * "Save pricing" stays disabled). */
export function asNumberOrEmpty(v: string | number): number | '' {
  if (typeof v === 'number') {
    return Number.isFinite(v) ? v : '';
  }
  const parsed = Number(v.replace(/[^0-9.-]/g, ''));
  return v.trim() !== '' && Number.isFinite(parsed) ? parsed : '';
}
